import { notification } from 'antd';
import * as services from '../../services/schoolService';

import { useState } from 'react';

export const useRegisterSchool = async (schoolDetails) => {
  const [loading, setLoading] = useState(false);
  try {
    setLoading(true);
    let data = await services.registerSchool(schoolDetails);
    notification['success']({
      message: 'School Created Succesfully',
    });
    setLoading(false);
    return { loading, data };
  } catch (error) {
    let errorList =
      error.response.data.data.errors[
        Object.keys(error.response.data.data.errors)[0]
      ];
    notification['error']({
      message: errorList[0],
    });
  }
};

export const resendOTP = async () => {
  let verificationKey = localStorage.getItem('verificationKey');
  try {
    await services.resendOTP({ verificationKey });
    notification['success']({
      message: 'OTP resent successfully',
    });
  } catch (error) {
    console.log(error);
    notification['error']({
      message: 'Unable to resend OTP, please try again',
    });
  }
};
